// import "./Footer.css";
import axios from "axios";
import { useContext, useEffect, useState, useTransition, startTransition,  useActionState } from "react";
import { format, addMilliseconds } from "date-fns";
import { Box, Grid, Paper, TextField } from '@mui/material';
import { Table, TableHead, TableRow, TableBody, TableCell } from '@mui/material';
import { Pagination, Stack, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
// import Paper from '@mui/material/Paper';

// Dialog関連
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from '@mui/material';

import CookieContext from "../contexts/CookieContext";
import ExpTimeContext from "../contexts/ExpTimeContext";

import AppContext from "../contexts/AppContext";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#e9dfdf',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

const AutoRefresh = () => {
  const { apiHost, AppButton } = useContext(AppContext);
  const basePath = 'autorefresh/';
  const { cookies, refreshJwtCookies } = useContext(CookieContext);
  const interval = 5000;
  const [id, setId] = useState("");
  const [ip, setIp] = useState("");

  const [elevation, setElevation] = useState('6');

  // intervalAccessTime = interval + responseTimeで接続の度に更新
  const [intervalAccessTime, setIntervalAccessTime] = useState(interval);
  // nextAccessTimeは次回アクセスの参考表示用
  const [nextAccessTime, setNextAccessTime] = useState(
    format(addMilliseconds(Date.now(), interval), "HH:mm:ss")
  );

  const [responseTime, setResponseTime] = useState(0);

  // 前回記録保持用
  const [lastRequestDateTime, setLastRequestDateTime] = useState("1999-12-31 23:59:59");
  const [lastResponseDateTime, setLastResponseDateTime] = useState("1999-12-31 23:59:59");

  const [error, setError] = useState();
  const [message, setMessage] = useState('');

  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [messageBoxId, setMessageBoxId] = useState('');
  const [messageBoxTitle, setMessageBoxTitle] = useState('');
  const [messageBoxMessage, setMessageBoxMessage] = useState('');


  const [targetItems, setTargetItems] = useState();
  const [paginator, setPaginator] = useState({count: 0, next: '', previous: '', current: 1, final: '', size: 0 })

  const [pagerIsPending, pagerStartTransition] = useTransition();
  const [page, setPage] = useState(1);

  const [loading, setLoading] = useState('');

  const handleMessageBoxOpen = (id, title, message) => {
    setMessageBoxTitle(title);
    setMessageBoxMessage(message);
    setMessageBoxOpen(true);
  }
  const handleMessageBoxClose = () => {
    setMessageBoxOpen(false);
  }

  const measure_time = async () => {
    const start_datetime = Date.now();
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        await axios({
          method: "get",
          url: apiHost + basePath,
          headers: {
            "Content-Type": "application/json",
            Authorization: `JWT ${cookies.jwtAccess}`,
          },
          params: {
            response_time: responseTime,
            // last_request_time: "1999-01-01 01:01:01",
            // last_response_time: "2000-01-01 01:01:01",
            last_request_datetime: lastRequestDateTime,
            last_response_datetime: lastResponseDateTime,
          },
        }).then(async (response) => {
          // alert(response.data[0].id + ' ' + response.data[0].ip_addr);
          // await console.log(response);
          // await setId(response.data[0].id);
          // await setIp(response.data[0].ip_addr);
        });
      } else {
        // jwtがない場合、headers（認証情報）無し
        await axios({
          method: "get",
          url: apiHost + basePath,
          params: {
            response_time: responseTime,
            // last_request_time: "2009-12-31 23:59:59",
            // last_response_time: "2010-12-31 23:59:59",
            last_request_datetime: lastRequestDateTime,
            last_response_datetime: lastResponseDateTime,
          },
        }).then(async (response) => {
          // alert(response.data[0].id + ' ' + response.data[0].ip_addr);
          // await console.log(response);
          // await setId(response.data[0].id);
          // await setIp(response.data[0].ip_addr);
        });
      }
    } catch (error) {
      return;
    }
    const end_datetime = Date.now();

    // 次回リクエスト時に送信するために値を格納
    await setLastRequestDateTime(format(start_datetime, "yyyy-MM-dd HH:mm:ss.SSS"));
    await setLastResponseDateTime(format(end_datetime, "yyyy-MM-dd HH:mm:ss.SSS"));
    await setResponseTime(end_datetime - start_datetime);

    await setIntervalAccessTime(interval + responseTime);
    await setNextAccessTime(format(addMilliseconds(Date.now(), interval + responseTime), "HH:mm:ss"));
  };

  // 初回アクセス時にデータ取得（2回目以降は「nextAccessTime」更新時に実行）
  useEffect(() => {
    fetchitems('?page=' + page);
    fetchpagers('?page=' + page);
  }, []);

  // 更新時間表示用（レスポンスタイム考慮有り）
  useEffect(() => {
    const timer = setInterval(
      () => {
        // axios_fetch();
        fetchitems('?page=' + page);
      },
      intervalAccessTime,
      []
    );
    return () => {
      clearInterval(timer);
    };
  }, [nextAccessTime]);

  // page変更時
  useEffect(() => {
    // fetchpagers('?page=' + page);
    fetchitems('?page=' + page);
  }, [page]);


  const postMessage = async () => {
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        };

        if (message) {
          startTransition(async () => {
            const response = await axios.post(`${apiHost}${basePath}targetitem/`, 
              {
                message: message,
              },
              {headers},
            )
  
            if (response.status === 201) {
              handleMessageBoxOpen(response.data.id, 'データ更新', 'データ更新が完了しました');
              setMessage('');

              // データを新規追加したので、現在ページを最新ページへ設定
              setPage(1);

              // 元々最新ページにいる場合はuseEffectが作用しないので、fetchitems=データ更新を実行
              // （最新ページにいない場合は上記のsetPage(1)でuseEffectが作用）
              fetchitems('?page=1');
            } else if (response.status === 401) {
              setError('ログインしてください');
            } else {
              setError('エラー');
            }
          });
        }
        else {
          handleMessageBoxOpen('xxx', 'エラー', 'メッセージを入れてください');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    } finally {
    }
  }

  const fetchitems = async (param) => {
    // 次回アクセス待機時間を計測
    measure_time();

    try {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${cookies.jwtAccess}`,
      };

      const response = await fetch(apiHost + basePath + 'targetitem/' + param, {headers});

      if (response.status === 200) {
        const data = await response.json();
        setTargetItems(data);
        fetchpagers('?page=' + page);
      }
      else if (response.status === 401) {
        setError('ログインしてください');
      }
      else {
        setError('エラー');
      }
    } catch (err) {
      console.log(err);
    }
  }

  const fetchpagers = async (param) => {
    // alert(param)
    measure_time();
    try {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${cookies.jwtAccess}`,
      };

      const responsePaginator = await fetch(apiHost + basePath + 'targetitem/history/' + param, {headers});

      if (responsePaginator.status === 200) {
        const dataPaginator = await responsePaginator.json();
        // var json = JSON.stringify(data);
        // setTargetItems(json);
        setPaginator({ ...paginator,
          count: dataPaginator.count,
          next: dataPaginator.next,
          previous: dataPaginator.previous,
          current: dataPaginator.current,
          final: dataPaginator.final,
          size: dataPaginator.size,
        });
      }
      else if (responsePaginator.status === 401) {
        setError('ログインしてください');
      }
      else {
        setError('エラー');
      }

      // setLoading(false);

    } catch (err) {
      console.log(err);
    }
  }

  return (
    <>
      <Box sx={{ flexGrow: 1, backgroundColor: '#f15858', padding: '10px' }}>
        <Grid container spacing={2}>
          <Grid size={4}>
            <Item>前回レスポンスタイム：{responseTime}ms</Item>
          </Grid>
          <Grid size={4}>
            <Item>前回リクエスト日時：{lastRequestDateTime}</Item>
          </Grid>
          <Grid size={4}>
            <Item>前回レスポンス日時：{lastResponseDateTime}</Item>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ backgroundColor: '#ffffff', padding: '10px' }}>
        <Grid container spacing={2}>
          <TextField id="message" fullWidth label="message" value={message} color="primary" focused onChange={(e) => setMessage(e.target.value)} />
          {/* <AppButton key={dataId} disabled={updateDisabled} onClick={() => {postMessage()}}>送信</AppButton> */}
          <AppButton onClick={() => {postMessage()}}>送信</AppButton>
          </Grid>
      </Box>


      <Dialog
          open={messageBoxOpen}
          onClose={handleMessageBoxClose}
          aria-labelledby="messageBox-dialog-title"
          aria-describedby="messageBox-dialog-description"

        >
          <DialogTitle sx={{m:0, p:2}} id="messageBox-dialog-title">
            【{messageBoxTitle}】
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText id="alert-dialog-description">
              {messageBoxMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <AppButton onClick={handleMessageBoxClose} autoFocus>OK</AppButton>
          </DialogActions>
        </Dialog>

      <div className="bd-callout bd-callout-limegreen" style={{ margin: "5px" }}>
        {/* データ一覧 */}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>id</TableCell>
              <TableCell>created_at</TableCell>
              <TableCell>message</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>

        {Array.isArray(targetItems)
          ? targetItems.map((targetItem, index) => {
            return (
              <>
                <TableRow>
                  <TableCell>【{targetItem.id}】</TableCell>
                  <TableCell>{format(targetItem.created_at, "yyyy-MM-dd HH:mm:ss")}</TableCell>
                  <TableCell>{targetItem.message}</TableCell>
                  <TableCell>{targetItem.ip_addr}</TableCell>
                </TableRow>
              </>
            )
          })
          : null
        }
          </TableBody>
        </Table>
      </div>

      {/* <div className="bd-callout bd-callout-limegreen" style={{ margin: "5px" }}> */}
      <div>
        {/* paginator */}
        <Box sx={{ flexGrow: 1, backgroundColor: '#a3f3e6', padding: '10px' }}>
        <Stack>
          {pagerIsPending
            ? <CircularProgress />
            : <Pagination count={paginator.final} page={paginator.current} color="primary" onChange={
              (e, page) => {
                setPage(page);
                pagerStartTransition(async() => {
                  await setPage(page)
                }
              )}
            } />
          }
        </Stack>
        </Box>
      </div>
      <div>
        <a href={paginator.previous}>前へ（cookie認証情報なしエラー）</a>
        <a href={paginator.next}>次へ（cookie認証情報なしエラー）</a>
      </div>
      <div>
        メッセージ数：{paginator.count}
      </div>

      <div className="bd-callout bd-callout-limegreen" style={{ margin: "5px" }}>
        【自動更新情報】
        <Box>
          <Grid container spacing={2}>
            <Grid size={3}>
              <Item elevation={elevation}>ip:{ip ? ip : "xxx.xxx.xxx.xxx"}</Item>
            </Grid>
            <Grid size={3}>
              <Item elevation={elevation}>応答時間:{responseTime}ms</Item>
            </Grid>
            <Grid size={3}>
              {/* <Item elevation={elevation}>nextAccessIntervalTime:{Math.round(intervalAccessTime / 100) / 10}s（{intervalAccessTime}ms）</Item> */}
              <Item elevation={elevation}>インターバル:{Math.round(intervalAccessTime / 100) / 10}秒</Item>
            </Grid>
            <Grid size={3}>
              <Item elevation={elevation}>
                ユーザ名:{cookies.accessTokenUsername ? cookies.accessTokenUsername : "guest"}
                ({cookies.accessTokenUserId ? cookies.accessTokenUserId : "-"})
              </Item>
            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  );
};
export default AutoRefresh
